import { Status, StatusApiData } from './CaseDetail'

export interface CaseReportingListApiData {
    kontaktTilNyansatStatusList: StatusApiData[]
    loenindplaceringStatusList: StatusApiData[]
    organisaeringStatusList: StatusApiData[]
}

export class CaseReportingList {
    kontaktTilNyansatStatusList: Status[] = []

    loenindplaceringStatusList: Status[] = []

    organisaeringStatusList: Status[] = []

    static build(data: CaseReportingListApiData): CaseReportingList {
        const caseReportingList = new CaseReportingList()
        caseReportingList.kontaktTilNyansatStatusList =
            data.kontaktTilNyansatStatusList.map((status) =>
                Status.build(status)
            )
        caseReportingList.loenindplaceringStatusList =
            data.loenindplaceringStatusList.map((status) =>
                Status.build(status)
            )
        caseReportingList.organisaeringStatusList =
            data.organisaeringStatusList.map((status) => Status.build(status))
        return caseReportingList
    }
}
